import { CustomerListView } from '@today/ui-domain'
import { LanguageSelector } from '@/components/LanguageSelector'
import { useCustomerList } from '@/hooks/customers/useCustomerList'

/** `/customers` — the customer list (TO-418 customer-ui REQ-003). */
export function CustomersListPage() {
	const list = useCustomerList()
	return (
		<div className="flex flex-col gap-4 p-6">
			<LanguageSelector />
			<CustomerListView {...list} />
		</div>
	)
}
